var map = {
	"./fish1.png": "YVEj",
	"./fish10.png": "Q8rD",
	"./fish100.png": "d+n2",
	"./fish101.png": "ayHb",
	"./fish11.png": "Yf/Y",
	"./fish12.png": "cHRX",
	"./fish13.png": "uYoK",
	"./fish14.png": "it0P",
	"./fish15.png": "MciH",
	"./fish2.png": "M6V6",
	"./fish26.png": "gQca",
	"./fish27.png": "lLYZ",
	"./fish28.png": "xjZz",
	"./fish29.png": "B+bA",
	"./fish3.png": "XHLl",
	"./fish30.png": "7Zty",
	"./fish31.png": "Rxch",
	"./fish32.png": "RVNP",
	"./fish33.png": "w504",
	"./fish4.png": "WCUA",
	"./fish40.png": "G1xP",
	"./fish41.png": "1lS6",
	"./fish42.png": "b0eh",
	"./fish43.png": "0kAR",
	"./fish44.png": "X9KF",
	"./fish45.png": "xYNR",
	"./fish5.png": "ErJu",
	"./fish50.png": "c6Eb",
	"./fish51.png": "UBfS",
	"./fish52.png": "5eqh",
	"./fish53.png": "cUID",
	"./fish54.png": "GowX",
	"./fish6.png": "Y1KA",
	"./fish7.png": "Gtg6",
	"./fish8.png": "SBeV",
	"./fish9.png": "kvN0",
	"./fish99.png": "dKT1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PIQ0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish ^\.\/fish.*\.png$
// module id = PIQ0
// module chunks = 0